var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 6,
    viewBox: "0 0 15 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L10 0.113249V5.88675L15 3ZM0 3.5H10.5V2.5H0V3.5Z",
    fill: "#202224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateArrow);
export default __webpack_public_path__ + "static/media/DateArrow.c7aa5d77c62180a45794eeed6681827f.svg";
export { ForwardRef as ReactComponent };